import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebSocketService } from '../shared/websocket.service';
import { ApiService } from '../shared/api.service';
import { safeRenderDrawing } from '../shared/drawing-validation.utils';

@Component({
  selector: 'app-streamer-view',
  templateUrl: './streamer-view.component.html',
  styleUrls: ['./streamer-view.component.scss']
})
export class StreamerViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('drawingCanvas', { static: false }) canvasRef!: ElementRef<HTMLCanvasElement>;
  drawings: any[] = [];
  private ctx!: CanvasRenderingContext2D;
  private subscriptions: Subscription[] = [];

  constructor(
    private websocketService: WebSocketService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.fetchApprovedDrawings();
    this.setupWebSocketSubscriptions();
  }

  ngAfterViewInit() {
    this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
    this.canvasRef.nativeElement.width = 1920;
    this.canvasRef.nativeElement.height = 1080;
    this.renderDrawings();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setupWebSocketSubscriptions() {
    // Subscribe to drawing updates
    const drawingUpdateSub = this.websocketService.getDrawingUpdates().subscribe(() => {
      console.log('Drawing update received, refreshing approved drawings');
      this.fetchApprovedDrawings();
    });

    // Subscribe to clear screen events
    const clearScreenSub = this.websocketService.getClearScreenEvents().subscribe(() => {
      console.log('Clear screen event received');
      this.clearCanvas();
      this.drawings = [];
    });

    this.subscriptions.push(drawingUpdateSub, clearScreenSub);
  }

  private clearCanvas() {
    if (this.ctx) {
      this.ctx.clearRect(0, 0, 1920, 1080);
    }
  }

  fetchApprovedDrawings() {
    this.apiService.getApprovedDrawings().subscribe({
      next: (data) => {
        this.drawings = data.drawings || [];
        this.renderDrawings();
      },
      error: (error) => {
        console.error('Error fetching approved drawings:', error);
      }
    });
  }

  renderDrawings() {
    if (!this.ctx) return;
    this.ctx.clearRect(0, 0, 1920, 1080);
    this.drawings.forEach(drawing => {
      this.renderDrawing(this.ctx, drawing.DrawingData, 1920, 1080);
    });
  }

  renderDrawing(context: CanvasRenderingContext2D, drawingData: any, width: number, height: number) {
    // Use safe rendering to handle malformed data
    safeRenderDrawing(
      context,
      drawingData,
      width,
      height,
      (error) => {
        console.error('Failed to render drawing in streamer view:', error);
      }
    );
  }
}
